import { observer } from "mobx-react-lite";
import React, { useLayoutEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import _ from "lodash";
import { get_color } from "../../report-visuals";

am4core.useTheme(am4themes_animated);

export const MultipleValueLineChart = observer(({ data, label, chartId = "multi_line_chart" }: any) => {
    const chartRef = useRef<am4charts.XYChart | null>(null);

    useLayoutEffect(() => {
        const chart = am4core.create(chartId, am4charts.XYChart);
        chart.data = data;
        chart.dateFormatter.inputDateFormat = "yyyy-MM-dd";
        chart.colors.step = 2;

        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.minGridDistance = 50;
        const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        const allSeries = _.uniq(
            data.flatMap((row: any) => Object.keys(row).filter((key) => key !== "date"))
        ) as string[];

        allSeries.forEach((field, index) => {
            const series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = field;
            series.dataFields.dateX = label;
            series.strokeWidth = 2;
            series.yAxis = valueAxis;
            series.name = field;
            series.tooltipText = "{name}: [bold]{valueY}[/]";
            series.tensionX = 0.8;
            series.stroke = am4core.color(get_color(index));
        });

        chart.legend = new am4charts.Legend();
        chart.cursor = new am4charts.XYCursor();
        chartRef.current = chart;

        return () => {
            chart.dispose();
        };
    }, [data, label, chartId]);

    return <div id={chartId} className="flex h-96 w-full flex-col" />;
});
